import { c as _c } from "react/compiler-runtime";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { setDueDay } from "../../../../../store/donation/actions";
import { State } from "../../../../../store/state";
import { DatePicker } from "../../../../shared/DatePicker/DatePicker";
import { ToolTip } from "../../../../shared/ToolTip/ToolTip";
import { Wrapper, DateBoxWrapper, DateTextWrapper, DateText } from "../../Vipps/VippsDatePicker/VippsDatePicker.style";
import { isIrregularChargeDay } from "./avtalegirodates";
import { DatePickerInputConfiguration } from "../../../../../../DatePicker/DatePickerInput";
import { Dispatch } from "@reduxjs/toolkit";
import { DonationActionTypes } from "../../../../../store/donation/types";
const tooltipText = "Vi må av tekniske grunner melde inn trekk til bankene tidligere enn din valgte trekkdato, derfor utsettes første trekk med én måned. Du kan velge en annen trekkdato om du ønsker å trekkes tidligere.";
export const AvtaleGiroDatePicker: React.FC<{
  configuration: DatePickerInputConfiguration;
}> = t0 => {
  const $ = _c(22);
  const {
    configuration
  } = t0;
  const dispatch = useDispatch();
  const dueDay = useSelector(_temp);
  const [selectedDueDay, setSelectedDueDay] = useState(dueDay);
  let t1;
  let t2;
  if ($[0] !== dispatch || $[1] !== selectedDueDay) {
    t1 = () => {
      dispatch(setDueDay(selectedDueDay));
    };
    t2 = [selectedDueDay, dispatch];
    $[0] = dispatch;
    $[1] = selectedDueDay;
    $[2] = t1;
    $[3] = t2;
  } else {
    t1 = $[2];
    t2 = $[3];
  }
  useEffect(t1, t2);
  let t3;
  if ($[4] !== configuration.payment_date_format_template || $[5] !== configuration.payment_date_last_day_of_month_template || $[6] !== dueDay) {
    t3 = dueDay === 0 ? configuration.payment_date_last_day_of_month_template : configuration.payment_date_format_template.replace("{{date}}", dueDay.toString());
    $[4] = configuration.payment_date_format_template;
    $[5] = configuration.payment_date_last_day_of_month_template;
    $[6] = dueDay;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  let t4;
  if ($[8] !== t3) {
    t4 = <DateText>{t3}</DateText>;
    $[8] = t3;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  let t5;
  if ($[10] !== selectedDueDay) {
    t5 = isIrregularChargeDay(selectedDueDay) && <ToolTip text={tooltipText} />;
    $[10] = selectedDueDay;
    $[11] = t5;
  } else {
    t5 = $[11];
  }
  let t6;
  if ($[12] !== t4 || $[13] !== t5) {
    t6 = <DateTextWrapper>{t4}{t5}</DateTextWrapper>;
    $[12] = t4;
    $[13] = t5;
    $[14] = t6;
  } else {
    t6 = $[14];
  }
  let t7;
  if ($[15] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = date => {
      setSelectedDueDay(date);
    };
    $[15] = t7;
  } else {
    t7 = $[15];
  }
  let t8;
  if ($[16] !== configuration || $[17] !== dueDay) {
    t8 = <DateBoxWrapper><DatePicker selected={dueDay} onChange={t7} onClickOutside={_temp2} configuration={configuration} /></DateBoxWrapper>;
    $[16] = configuration;
    $[17] = dueDay;
    $[18] = t8;
  } else {
    t8 = $[18];
  }
  let t9;
  if ($[19] !== t6 || $[20] !== t8) {
    t9 = <Wrapper>{t6}{t8}</Wrapper>;
    $[19] = t6;
    $[20] = t8;
    $[21] = t9;
  } else {
    t9 = $[21];
  }
  return t9;
};
function _temp(state) {
  return state.donation.dueDay;
}
function _temp2() {}